import { jsx as _jsx } from "react/jsx-runtime";
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cva } from 'class-variance-authority';
import * as React from 'react';
import { cn } from './utils/shadcn-utils';
const TabsVariantContext = React.createContext('default');
function Tabs({ className, variant, ...props }) {
    return (_jsx(TabsVariantContext.Provider, { value: variant ?? 'default', children: _jsx(TabsPrimitive.Root, { "data-slot": "tabs", className: cn('flex flex-col gap-2', className), ...props }) }));
}
const tabsListVariants = cva('inline-flex items-center', {
    variants: {
        variant: {
            default: 'bg-muted text-muted-foreground h-9 w-fit justify-center rounded-md p-[3px] gap-1',
            underline: 'text-muted-foreground w-full gap-2 border-b border-input-border'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});
function TabsList({ className, variant: variantProp, ...props }) {
    const variantFromContext = React.useContext(TabsVariantContext);
    const variantToUse = variantProp ?? variantFromContext;
    return _jsx(TabsPrimitive.List, { "data-slot": "tabs-list", className: tabsListVariants({ variant: variantToUse, className }), ...props });
}
const tabsTriggerVariants = cva("cursor-pointer inline-flex items-center justify-center gap-1.5 text-base whitespace-nowrap transition-[color,box-shadow,background-color] focus-visible:ring-[var(--focus-ring-width)] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", {
    variants: {
        variant: {
            default: 'data-[state=active]:bg-background dark:data-[state=active]:text-foreground focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring dark:data-[state=active]:border-input-border dark:data-[state=active]:bg-input/30 text-foreground dark:text-muted-foreground data-[state=inactive]:hover:bg-background/60 dark:data-[state=inactive]:hover:bg-input/20 h-[calc(100%-1px)] flex-1 rounded-md px-4 py-1 data-[state=active]:shadow-sm',
            underline: 'bg-transparent text-muted-foreground hover:text-foreground/90 px-3 py-2 border-b-2 border-transparent focus-visible:border-ring focus-visible:ring-ring/50 data-[state=active]:text-foreground data-[state=active]:border-foreground'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});
function TabsTrigger({ className, variant: variantProp, ...props }) {
    const variantFromContext = React.useContext(TabsVariantContext);
    const variantToUse = variantProp ?? variantFromContext;
    return _jsx(TabsPrimitive.Trigger, { "data-slot": "tabs-trigger", className: tabsTriggerVariants({ variant: variantToUse, className }), ...props });
}
function TabsContent({ className, ...props }) {
    return _jsx(TabsPrimitive.Content, { "data-slot": "tabs-content", className: cn('flex-1 outline-none', className), ...props });
}
export { Tabs, TabsContent, TabsList, tabsListVariants, TabsTrigger, tabsTriggerVariants };
//# sourceMappingURL=tabs.js.map